import React from 'react'
import Box from '@mui/material/Box'
import MUIBreadcrumbs from '@mui/material/Breadcrumbs'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Breadcrumb from './Breadcrumb'

const Breadcrumbs = props => {
  const { crumbs } = props

  if (!crumbs) {
    return null
  }

  return (
    <Box my={2} displayPrint='none'>
      <MUIBreadcrumbs
        separator={<NavigateNextIcon fontSize='small' />}
        aria-label='breadcrumb'
      >
        {crumbs.map(crumb => (
          <Breadcrumb
            text={crumb[0]}
            link={crumb[1]}
            href={crumb[2]}
            key={crumb[0]}
          />
        ))}
      </MUIBreadcrumbs>
    </Box>
  )
}

export default Breadcrumbs
